import API from 'services/api';

export interface IAtlasTrigger {
  automationId?: number;
  calculationId: string;
}

export const postAtlasCalculationTrigger = ({ payload }: { payload: IAtlasTrigger }) =>
  API.post(`/api/atlas/calculation/trigger`, payload);
